// extracted by mini-css-extract-plugin
export default {"card":"xea-z","carousel":"yea-z"};